import _ from "lodash";
import { forwardRef, useEffect, useState } from "react";
import { dateFormatNonGrid, mapRowId } from "../../common/commonFunctions";
import moment from "moment";
import axios from "axios";
import {
  Card,
  CardContent,
  CardHeader,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import {
  appColor,
  constants,
  EndPoint,
  messages,
} from "../../common/constants";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import SearchIcon from "@mui/icons-material/Search";
import LocatePNLGrid from "./Grid";
import RefreshIcon from "@mui/icons-material/Refresh";

import excel from "../../assets/images/excel.svg";
import { exportMultipleSheetsAsExcel } from "ag-grid-enterprise";
import { Split } from "@geoffcox/react-splitter";
import SummaryPieChart from "../../components/SummaryPieChart";
import SpinnerFullScreen from "../../components/SpinnerFullScreen";
import swal from "sweetalert";
import { serviceAPIMapping } from "../../config/service-api-mapping";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LineGraph } from "../../components/LineGraph";
import { useRef } from "react";
import { isServiceHealthy } from "../../utils/API";

const LocatePNL = () => {
  const [locatePNLRows, setLocatePNLRows] = useState<any>([]);
  const [snackbarMessage, setSnackbarMessage] = useState<any>("");
  const [refLoanReturns, setRefLoanReturns] = useState<any>(null);
  const lineGraphRef = useRef<any>(null);
  const [open, setOpen] = useState(false);
  const [gridApiSec, setGridApiSec] = useState<any>(null);
  const [heightAG_1] = useState(84);
  const [lastUpdatedDate, setLastUpdatedDate] = useState(
    moment(new Date()).format("MM/DD/yyyy HH:mm")
  );
  const [groupByClientData, setGroupByClientData] = useState<any>({
    labels: [],
    values: [],
  });
  const [groupByTickerData, setGroupByTickerData] = useState<any>({
    labels: [],
    values: [],
  });
  const [minDate, setMinDate] = useState<any>(
    moment().startOf("month")?.toDate()
  );
  const [maxDate, setMaxDate] = useState<any>(new Date());
  const [isInitialRefresh, setIsInitialRefresh] = useState(true);
  const [showGetDataLoader, setShowGetDataLoader] = useState<boolean>(false);
  const [isSmallerDeviceRes, setIsSmallerDeviceRes] = useState<boolean>(
    window?.innerWidth < 992
  );
  const [isDateRangeValid, setDateRangeValid] = useState(true);
  const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref
  ) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  const [isMonthlyFilterActive, setIsMonthlyFilterActive] = useState(true);
  const [isCustomFilterActive, setIsCustomFilterActive] = useState(false);
  const [isYearlyFilterActive, setIsYearlyFilterActive] = useState(false);
  const [isCurrentDateFilterActive, setIsCurrentDateFilterActive] =
    useState(false);
  const [clientHistory, setClientHistory] = useState<any>([]);
  const [clientHistorySeries, setClientHistorySeries] = useState<any>([]);

  useEffect(() => {
    const groupByLender = _.groupBy(locatePNLRows, "client");
    const groupByTicker = _.groupBy(locatePNLRows, "sec_id");

    const groupByLenderLabelValue: any[] = [];
    const groupByTickerLabelValue: any[] = [];
    Object.entries(groupByTicker).map(([key, value]) => {
      value.map((item: any) => {
        item.value =
          item.pnl && !_.isNaN(item.pnl) && _.isString(item.pnl)
            ? parseFloat(item.pnl)
            : 0;
      });
      const totalValue = _.sumBy(value, "pnl");
      groupByTickerLabelValue.push({
        label: key,
        value: totalValue ? totalValue : 0,
      });
    });
    Object.entries(groupByLender).map(([key, value]) => {
      value.map((item: any) => {
        item.value =
          item.pnl && !_.isNaN(item.pnl) && _.isString(item.pnl)
            ? parseFloat(item.pnl)
            : 0;
      });
      const totalValue = _.sumBy(value, "pnl");
      groupByLenderLabelValue.push({
        label: key,
        value: totalValue ? totalValue : 0,
      });
    });
    const top10GroupByTicker = _.sortBy(groupByTickerLabelValue, "value")
      .reverse()
      .slice(0, 10);
    const top10GroupByLender = _.sortBy(groupByLenderLabelValue, "value")
      .reverse()
      .slice(0, 10);
    setGroupByClientData({
      labels: _.map(top10GroupByLender, "label"),
      values: _.map(top10GroupByLender, "value"),
    });
    setGroupByTickerData({
      labels: _.map(top10GroupByTicker, "label"),
      values: _.map(top10GroupByTicker, "value"),
    });

    const history = locatePNLRows.map((r: any) => ({
      [r.client]: r.pnl,
      date: new Date(r.filled),
      ...r,
    }));

    const series: any[] = [];
    history.map((h: any) => {
      series.push({
        type: "bar",
        xKey: "date",
        xName: "Date",
        yKey: h.client,
        yName: h.client,
        connectMissingData: true,
        stacked: true
      });
    });
    const uniqueSeries = _.unionBy(series, "yKey");
    setClientHistory(history);
    setClientHistorySeries(uniqueSeries);
        setShowGetDataLoader(false);

  }, [locatePNLRows]);

 

  const getLocatePNLHistory = async () => {
  setShowGetDataLoader(true); 
  setLocatePNLRows([]); 

  try {
    const request = {
      function_code: "fn_rpt_get_locatepnl_hist_byclient_bysec",
      function_param: {
        min_date_in: moment(minDate).format("YYYY-MM-DD"),
        max_date_in: moment(maxDate).format("YYYY-MM-DD"),
      },
    };

    const token = window.localStorage.getItem("refreshtoken");
    const header = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

  
    const response = await axios.post(
      `${serviceAPIMapping["REPORTING-SERVICE"].apiRouteURL}${EndPoint.reportFn}`,
      request,
      { headers: header }
    );

    if (!response || !response.data) {
      setOpen(true);
      setSnackbarMessage("Reporting" + messages.serviceDownMessage);
      return;
    }

    const data = response.data;
    if (data && !_.isEmpty(data)) {
      const mappedRows = mapRowId(data);
      const updatedRows = mappedRows.map((r: any) => ({
        ...r,
        pnl: r?.pnl
          ? parseFloat(parseFloat(r?.pnl?.toString())?.toFixed(3))
          : 0,
        filled: dateFormatNonGrid(r?.filled),
      }));

      // Update UI as soon as mapping is done
      setLocatePNLRows(updatedRows);
    } else {
      setLocatePNLRows([]);
    }
  } catch (err) {
    console.error(err);
    setLocatePNLRows([]);
  } finally {
    // Hide loader as soon as the request finishes
    setShowGetDataLoader(false);
  }
};

  // const refreshGrid = () => {
  //   setShowGetDataLoader(true); 
  //   setLastUpdatedDate(moment(new Date()).format("MM/DD/yyyy HH:mm"));
  //   getLocatePNLHistory();
  // };
const refreshGrid = async () => {
  setShowGetDataLoader(true);
  setLastUpdatedDate(moment().format("MM/DD/YYYY HH:mm"));
  
  try {
    await getLocatePNLHistory();
  } finally {
    setShowGetDataLoader(false);
  }
};

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === constants.clickaway) {
      return;
    }

    setOpen(false);
  };

  const onFilterTextChange = _.debounce((e: any) => {
    gridApiSec?.setQuickFilter(e.target.value);
  }, 800);

  useEffect(() => {
    if (isInitialRefresh) {
      getServiceHealthCheck();
      setIsInitialRefresh(false);
    }
  }, []);

  useEffect(() => {
    let isValid = true;
    if (
      !isInitialRefresh &&
      minDate &&
      moment.isDate(minDate) &&
      maxDate &&
      moment.isDate(maxDate)
    ) {
      isValid = moment(minDate).isSameOrBefore(maxDate, "day");
      setDateRangeValid(isValid);
           let refreshTimer: NodeJS.Timeout;

    if (isValid) {
      refreshTimer = setTimeout(() => {
        refreshGrid();
      }, 300);
    }

      if (isMonthlyFilterActive &&
        !(
          moment().isSame(maxDate, "day") &&
          moment(moment().startOf("month")?.toDate()).isSame(minDate, "day")
        )
      ) {
        setIsMonthlyFilterActive(false);
      } else if (isYearlyFilterActive && 
        !(
          moment().isSame(maxDate, "day") &&
          moment(moment().startOf("year")?.toDate()).isSame(minDate, "day")
        )
      ) {
        setIsYearlyFilterActive(false);
      } else if (isCurrentDateFilterActive && !(
        moment().isSame(maxDate, "day") &&
        moment().isSame(minDate, "day"))
      ) {
        setIsCurrentDateFilterActive(false)
      }
      return () => clearTimeout(refreshTimer);

    }
  }, [maxDate, minDate]);

  useEffect(() => {
    if (isMonthlyFilterActive) {
      setMinDate(moment().startOf("month")?.toDate());
      setMaxDate(new Date());
    } else if (isYearlyFilterActive) {
      setMinDate(moment().startOf("year")?.toDate());
      setMaxDate(new Date());
    } else if (isCurrentDateFilterActive) {
      setMinDate(new Date());
      setMaxDate(new Date());
    }
  }, [isMonthlyFilterActive, isYearlyFilterActive, isCurrentDateFilterActive]);

  function onExcelExport() {
    var spreadsheets = [];
    spreadsheets.push(
      refLoanReturns?.current?.api?.getSheetDataForExcel?.({
        sheetName: "Locate-PNL",
      })!
    );

    exportMultipleSheetsAsExcel({
      data: spreadsheets,
      fileName: "locate-pnl.xlsx",
    });
  }

  const getCardHeight = () => {
    const offsetHeight = document?.getElementById("supply-title")?.offsetHeight;
    const divHeight = _.isUndefined(offsetHeight) ? 2 : offsetHeight + 12;

    return "calc(100% - " + divHeight + "px)";
  };

  useEffect(() => {
    // Function to handle the resize event
    function handleResize() {
      setIsSmallerDeviceRes(window.innerWidth <= 992);
    }

    // Add the event listener
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getServiceHealthCheck = async () => {
      await isServiceHealthy(
        `${serviceAPIMapping["REPORTING-SERVICE"].apiRouteURL}/${EndPoint.actuator}`
      ).then((response: any) => {
        if (!response?.ok || response?.status === 503) {
          setSnackbarMessage(`Reporting ${messages.serviceDownMessage}`);
          setOpen(true);
        } else {
          refreshGrid();
        }
      });
    };

const getUI = () => {
  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column", minHeight: 0 }}>
      <div style={{ flex: 1, display: "flex", minHeight: 0 }}>
        <Split initialPrimarySize="65%" horizontal>
          <div style={{ height: "100%", display: "flex", flexDirection: "column", minHeight: 0 }}>
            <Split initialPrimarySize="70%">
              <div style={{ height: "100%", minHeight: 0 }}>
                <LocatePNLGrid
                  rowData={locatePNLRows}
                  height={heightAG_1}
                  type="SupplyManagement"
                  getBtnRef={(gridRef: any) => setRefLoanReturns(gridRef)}
                  getGridApi={(gridApi: any) => setGridApiSec(gridApi)}
                />
              </div>
              <div style={{ height: "100%", display: "flex", flexDirection: "column", minHeight: 0 }}>
                <div style={{ flex: 1, overflow: "auto", minHeight: 0 }}>
                  <SummaryPieChart
                    title="Group by Client (Top 10)"
                    summaryChartInfo={groupByClientData}
                  />
                </div>
                <div style={{ flex: 1, overflow: "auto", minHeight: 0 }}>
                  <SummaryPieChart
                    title="Group by Symbol (Top 10)"
                    summaryChartInfo={groupByTickerData}
                  />
                </div>
              </div>
            </Split>
          </div>
          <div style={{ height: "100%", display: "flex", flexDirection: "column", minHeight: 0 }}>
            <Card className="w-100 p-0 mt-1 ps-0 h-100" style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
              <CardHeader
                className="p-0 ps-2"
                subheader={
                  <Typography sx={{ color: appColor }}>
                    PNL Locate Client History by Date
                  </Typography>
                }
              />
              <CardContent className="w-100 p-0" style={{ flex: 1, minHeight: 0 }}>
                <LineGraph
                  ref={lineGraphRef}
                  series={clientHistorySeries}
                  history={clientHistory}
                />
              </CardContent>
            </Card>
          </div>
        </Split>
      </div>
    </div>
  );
};
  const getSmallerDevicesUI = () => {
    return (
      <div className="row" style={{ overflow: "auto" }}>
        <div style={{ height: "30vh" }} className="col">
          <LocatePNLGrid
            rowData={locatePNLRows}
            height={heightAG_1}
            type="SupplyManagement"
            getBtnRef={(gridRef: any) => {
              setRefLoanReturns(gridRef);
            }}
            getGridApi={(gridApi: any) => {
              setGridApiSec(gridApi);
            }}
          />
        </div>
        <div className={`mb-1 h-100 row`}>
          <SummaryPieChart
            title="Group by Client (Top 10)"
            summaryChartInfo={groupByClientData}
          ></SummaryPieChart>
        </div>
        <div className={`mb-1 h-100 row`}>
          <SummaryPieChart
            title="Group by Symbol (Top 10)"
            summaryChartInfo={groupByTickerData}
          ></SummaryPieChart>
        </div>
        <div className={`mb-1 h-100 row`}>
            <Card className="w-100 p-0 mt-1 ps-0 h-100">
              <CardHeader
                className="p-0 ps-2"
                subheader={
                  <Typography sx={{ color: appColor }}>
                    PNL Locate Client History by Date
                  </Typography>
                }
              ></CardHeader>
              <CardContent className="w-100 p-0" style={{height:'27vh'}}>
                <LineGraph
                  series={clientHistorySeries}
                  history={clientHistory}
                ></LineGraph>
              </CardContent>
            </Card>
          </div>
      </div>
    );
  };

  const getMinDatePicker = () => {
    return (
      <>
        <div
          className={`pe-2 ${
            isSmallerDeviceRes
              ? "col col-sm-12 w-100 mt-1 w-100"
              : "d-flex align-items-center align-content-center"
          }`}
        >
          <span className="me-2 text-nowrap" style={{ fontWeight: "600" }}>
            Min Date
          </span>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              disableFuture
              openTo="day"
              className="onFocusOutTermDateID"
              views={["year", "month", "day"]}
              maxDate={moment(maxDate).toDate()}
              value={minDate}
              inputFormat="yyyy-MM-dd"
              InputProps={{
                notched: false,
                style: { fontSize: 13, color: "#212529" },
              }}
              onChange={(newValue: any) => {
                setMinDate(newValue);
              }}
              renderInput={(params: any) => (
                <TextField
                  variant="outlined"
                  sx={{
                    "& .MuiInputBase-input": {
                      height: "0.4rem",
                      width: "4.4rem",
                    },
                  }}
                  label={"Max Date"}
                  className="inputStyleNew"
                  InputLabelProps={{ shrink: true, fontSize: 10 }}
                  {...params}
                />
              )}
            />
          </LocalizationProvider>
        </div>
      </>
    );
  };

  const getMaxDatePicker = () => {
    return (
      <>
        <div
          className={`pe-2 ${
            isSmallerDeviceRes
              ? "col col-sm-12 w-100 mt-1 w-100"
              : "d-flex align-items-center align-content-center"
          }`}
        >
          <span className="me-1 text-nowrap" style={{ fontWeight: "600" }}>
            Max Date
          </span>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              disableFuture
              openTo="day"
              className="onFocusOutTermDateID"
              views={["year", "month", "day"]}
              maxDate={moment().toDate()}
              value={maxDate}
              inputFormat="yyyy-MM-dd"
              InputProps={{
                notched: false,
                style: { fontSize: 13, color: "#212529" },
              }}
              onChange={(newValue: any) => {
                setMaxDate(newValue);
              }}
              renderInput={(params: any) => (
                <TextField
                  variant="outlined"
                  sx={{
                    "& .MuiInputBase-input": {
                      height: "0.4rem",
                      width: "4.4rem",
                    },
                  }}
                  label={"Max Date"}
                  className="inputStyleNew"
                  InputLabelProps={{ shrink: true, fontSize: 10 }}
                  {...params}
                />
              )}
              minDate={moment(minDate).toDate()}
            />
          </LocalizationProvider>
        </div>
      </>
    );
  };


const handleMonthToDateClick = () => {
  setShowGetDataLoader(true)
  setIsYearlyFilterActive(false);
  setIsMonthlyFilterActive(true);
  setIsCurrentDateFilterActive(false);
  setIsCustomFilterActive(false); // optional
  const from = moment().startOf("month").toDate();
  const to = new Date();

  setMinDate(from);
  setMaxDate(to);
  refreshGrid();
};

const getMTDButton = () => {
  return (
    <div
      className={`pe-2 ${
        isSmallerDeviceRes
          ? "col mt-1 w-100"
          : "h-100 metrics-div me-2 d-flex align-items-center align-content-center"
      }`}
    >
      <button
        type="button"
        onClick={handleMonthToDateClick}
        className={`metrics-btn p-1 d-flex h-75 align-items-center btn btn-mtd text-nowrap ${
          isMonthlyFilterActive ? "btn btn-filter-active" : ""
        }`}
      >
        Month To Date
      </button>
    </div>
  );
};

  const getYTDButton = () => {
    return (
      <>
        <div
          className={`pe-2 ${
            isSmallerDeviceRes
              ? "col mt-1 w-100"
              : "h-100 metrics-div me-2 d-flex align-items-center align-content-center"
          }`}
        >
          <button
            type="button"
            onClick={() => {
              setIsMonthlyFilterActive(false);
              setIsYearlyFilterActive(true);
              setIsCurrentDateFilterActive(false);
              const from = moment().startOf("year")?.toDate();
  const to = new Date();
  setMinDate(from);
  setMaxDate(to);

  setTimeout(() => refreshGrid(), 0);
            }}
            className={`metrics-btn p-1 d-flex h-75 align-items-center btn btn-settled text-nowrap ${
              isYearlyFilterActive ? "btn btn-filter-active" : ""
            }`}
          >
            Year To Date
          </button>
        </div>
      </>
    );
  };

  const getTodayButton = () => {
    return (
      <>
        <div
          className={`pe-2 ${
            isSmallerDeviceRes
              ? "col w-100 mt-1"
              : "h-100 metrics-div me-2 d-flex align-items-center align-content-center"
          }`}
        >
          <button
            type="button"
            onClick={() => {
              setIsMonthlyFilterActive(false);
              setIsYearlyFilterActive(false);
              setIsCurrentDateFilterActive(true);
              
  const today = new Date();
  setMinDate(today);
  setMaxDate(today);

  setTimeout(() => refreshGrid(), 0);
              
            }}
            className={`metrics-btn p-1 d-flex h-75 align-items-center btn btn-current-date text-nowrap ${
              isCurrentDateFilterActive ? "btn btn-filter-active" : ""
            }`}
          >
            Current Date
          </button>
        </div>
      </>
    );
  };

  return (
    <>
      <Snackbar open={open} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="error"
          sx={{
            width: "100%",
            backgroundColor: "orange",
            textDecorationColor: "white",
          }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      {showGetDataLoader && <SpinnerFullScreen />}
      <div id="supply-title" className="mb-1" style={{ paddingLeft: "20px" }}>
        Locate PNL
      </div>
     
      <Card
  style={{
    height: "calc(100vh - 100px)", 
    display: "flex",
    flexDirection: "column"
  }}
>
  <CardContent
    style={{
      flex: 1,
      display: "flex",
      flexDirection: "column",
      overflow: "hidden"
    }}
  >
          <div className="d-flex flex-row row">
            <div
              className={`d-flex flex-row justify-content-start col mb-0 mt-0 align-items-center ${
                isSmallerDeviceRes ? "col row mt-1" : ""
              }`}
            >
              <div
                className="globalfiltermaindivSec"
                style={{
                  width: isSmallerDeviceRes ? "60%" : "45%",
                  marginLeft: 0,
                }}
              >
                <input
                  type="search"
                  placeholder="Global search..."
                  id="filter-text-box-sec"
                  onInput={onFilterTextChange}
                />
                <SearchIcon style={{ fontSize: "1rem", color: "#1e355e" }} />
              </div>
              <div className="d-flex flex-row justify-content-start align-content-center row">
                {isSmallerDeviceRes && getYTDButton()}
                {isSmallerDeviceRes && getMTDButton()}
                {isSmallerDeviceRes && getTodayButton()}
              </div>

              {isSmallerDeviceRes && getMinDatePicker()}
              {isSmallerDeviceRes && getMaxDatePicker()}
            </div>
            <div
              className={`col d-flex align-items-center justify-content-end sm-md-mt-2-rem ${
                isSmallerDeviceRes ? "col row" : ""
              }`}
            >
              <div className="row col d-flex align-items-center justify-content-end sm-md-mt-2-rem mt-1">
                <div className=" col d-flex align-items-center justify-content-end sm-md-mt-2-rem">
                  {!isSmallerDeviceRes && getYTDButton()}
                  {!isSmallerDeviceRes && getMTDButton()}
                  {!isSmallerDeviceRes && getTodayButton()}
                  {!isSmallerDeviceRes && getMinDatePicker()}
                  {!isSmallerDeviceRes && getMaxDatePicker()}
                </div>
                {!isDateRangeValid && (
                  <span className="d-flex justify-content-end small pe-2 error-style">
                    Please select valid date range
                  </span>
                )}
              </div>
              <div
                className={`borrowExceldnld ${isSmallerDeviceRes ? "col" : ""}`}
                onClick={() => {
                  onExcelExport();
                }}
                title="Download Excel"
              >
                <img
                  src={excel}
                  alt=""
                  style={{
                    height: "1.8rem",
                    width: "1.8rem",
                    cursor: "pointer",
                  }}
                />
              </div>
              <div
                className={`d-flex justify-content-end cursor-pointer pr-1 align-items-center ${
                  isSmallerDeviceRes ? "col" : ""
                }`}
                onClick={refreshGrid}
                title="Refresh Data"
              >
                <RefreshIcon
                  style={{
                    cursor: "pointer",
                    marginRight: "0.5rem",
                    color: "#1E355E",
                  }}
                />
                <div className="refreshsettimedateContract">
                  <div>Last updatede on: </div>
                  <div>{lastUpdatedDate}</div>
                </div>
              </div>
            </div>
          </div>
          <hr className="my-0"></hr>

          {isSmallerDeviceRes ? <>{getSmallerDevicesUI()}</> : <>{getUI()}</>}
        </CardContent>
      </Card>
    </>
  );
};

export default LocatePNL;


